import { ANSWER_TYPES } from 'src/utils/constants/BuyPolicy'
import ToggleButton from 'src/components/BuyPolicy/common/ToggleButton/ToggleButton'
import { FormControl, MenuItem, Select, TextField } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const DynamicAnswerControl = ({ question, onChange }) => {
  const classes = useStyles()
  const getAnswerControl = () => {
    switch (question?.answerType) {
      case ANSWER_TYPES?.BOOLEAN:
        return (
          <>
            <ToggleButton
              id='ToggleButton'
              onClick={(toggledValue) => onChange(toggledValue)}
              checked={question?.isApplicable}
            />
          </>
        )
      case ANSWER_TYPES?.TEXT_DESCRIPTION:
        return (
          <div>
            <TextField
              id='TextField'
              label='Please specify'
              multiline
              rows={3}
              className={classes.textField}
              name=''
              type='text'
              value={question?.detailAnswer}
              onChange={(event) => onChange(event?.target?.value)}
            />
          </div>
        )
      case ANSWER_TYPES.DATE:
        return (
          <div>
            <input
              id='DateField'
              name='date'
              type='date'
              placeholder='subQuestionDate'
              className={`${classes.textField} ${classes.dateField}`}
              value={question?.detailAnswer}
              onChange={(event) => onChange(event?.target?.value)}
            />
          </div>
        )
      case ANSWER_TYPES?.DOMAIN:
        return (
          <div>
            <FormControl className={classes.formControlStyles} size='small'>
              <Select
                id='SelectControl'
                value={question?.detailAnswer}
                onChange={(event) => onChange(event?.target?.value)}
                displayEmpty
                className={classes.selectField}
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value=''>None</MenuItem>
                {question?.domainValues?.map((domainValueItem) => {
                  return (
                    <MenuItem
                      value={domainValueItem?.domainCode}
                      key={'domainValueItem'}
                    >
                      {domainValueItem?.domainValue}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </div>
        )
      default:
        return null
    }
  }

  return <>{getAnswerControl()}</>
}

export default DynamicAnswerControl

const useStyles = makeStyles({
  textField: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    width: '100%',
    padding: '12px 8px',
    border: '1px solid #A1A1A1',
    borderRadius: '5px',
  },
  formControlStyles: {
    minWidth: 120,
    margin: 1,
  },
  dateField: {
    width: 'calc(100%  - 16px) !important',
  },
  selectField: {
    '&  .MuiInputBase-root': {
      height: '0.7rem !important',
      minHeight: 'unset',
      // width:'100px',
    },
    '&  .MuiSelect-select': {
      minHeight: 'unset',
      // width:'100px',
    },
  },
})
